import { Component, ViewChild, OnInit, Output, EventEmitter }            from '@angular/core';
import { ModalDirective }                                                from 'ng2-bootstrap/modal';
import { RoleService}                                                    from '../../services/role.service';
import { Role }                                                          from '../../models/role';
import { Subject }                                                       from 'rxjs/Subject';

@Component({
  selector: 'role-edit',
  templateUrl: './role-edit.component.html',
  styleUrls: ["role-edit.component.scss"]
})

export class RoleEditComponent implements OnInit {
    private id: string;
    private name: string;

    @Output() roleEdited = new EventEmitter();
    @ViewChild('modal') modal:ModalDirective;

    private role: Role;
    private ngUnsubscribe: Subject<void> = new Subject<void>();

    constructor(private roleService: RoleService) {}

    show(id: string): void {
        this.roleService.getRole(id)
        .subscribe(role => this.role = role);
        this.modal.show();
    }

    ngOnInit(): void {
        this.role = new Role()
        this.role.name = "";
    }

    update(role): void {
        this.roleService.update(role).subscribe(() => {
          this.roleEdited.emit(role);
          this.modal.hide()
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/users/components/role-edit/role-edit.component.ts